// extracted by mini-css-extract-plugin
export default {"pointer":"ItemContent_pointer_q98td"};